import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  store: null,
  permissions:null,
  userStores: []
};

const storeSlice = createSlice({
  name: "storage",
  initialState,
  reducers: {
    clear: (state) => initialState,
    storeSet: (state, action) => {
      state.store = action.payload;
      return state;
    },
    setStorePermissions: (state, action) => {
      state.permissions = action.payload;
      return state;
    },
    storeGet: (state, action) => {
      return state.store;
    },
    setUserStores: (state, action) => {
      state.userStores = action.payload;
      return state;
    }
  },
});

export const { clear, storeSet, storeGet,setStorePermissions, setUserStores } = storeSlice.actions;
export default storeSlice.reducer;
